import { isMobileOnly, isTablet } from "../../../util/deviceDetect";
import { detect } from "detect-browser";

/**
 * Retrieves information on the platform, browser, and OS executing the code
 *
 * @returns {{platform: string, OS: string, browserName: string}}
 */
const getDeviceInfo = () => {
    let retVal = undefined;

    try {
        const browser = detect();
        let platform = "React_Native";

        if (window?.navigator?.userAgent) {
            platform = "Desktop";

            if (isMobileOnly) {
                platform = "Mobile";
            } else if (isTablet) {
                platform = "Tablet";
            }
        }

        retVal = {
            platform,
            OS: browser.os ? browser.os.replace(/\s/g, "_") : browser.os,
            browserName: browser.name,
        };
    } catch (e) {
        retVal = undefined;
    }

    return retVal;
};

export {
    getDeviceInfo,
};
